<template>
  <div class="detail-page page">
    <div class="page-header">
      <div class="header-left" @click="onClickLeft">
        <van-icon name="arrow-left" />
      </div>
      <div class="header-title">{{ profileCode }}</div>
      <div class="header-right"></div>
    </div>

    <div class="banner">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#fff">
        <van-swipe-item
          v-for="(image, index) in displayImages"
          :key="`${image}-${index}`"
        >
          <img
            :src="image"
            class="banner-img"
            :alt="$t('detail.image_alt')"
            @click="imgShow(image)"
          />
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="certification-buttons">
      <button class="cert-btn cert-btn-left">✓{{ $t("detail.certification") }}</button>
      <button class="cert-btn cert-btn-right">✓{{ $t("detail.video_authentication") }}</button>
    </div>

    <div class="detail-body">
      <div class="profile-title">{{ profileCode }}</div>

      <div class="voting-info">
        <span class="voting-text">{{ $t("detail.voting_competition") }}: {{ votingCount }}</span>
      </div>

      <div class="basic-info">
        <span>{{ basicInfoText }}</span>
      </div>

      <div class="service-section">
        <span class="service-text">{{ $t("detail.serving_city") }} {{ serviceCity }}</span>
        <button class="movie-btn" @click="openMovie">{{ $t("detail.my_movie") }}</button>
      </div>

      <div v-if="videoUrl" ref="movieSection" class="movie-section">
        <div class="movie-section-title">{{ $t("detail.my_movie") }}</div>
        <video
          :src="videoUrl"
          class="detail-video"
          controls
          playsinline
          :poster="displayImages[0]"
        ></video>
      </div>

      <div class="summary-section">
        <div class="summary-title">{{ $t("detail.summary") }}</div>
        <div class="summary-content">
          <p>{{ summaryText }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { normalizeMediaUrl } from "../../utils/media";

export default {
  data() {
    return {
      data: {},
    };
  },
  computed: {
    displayImages() {
      const images = Array.isArray(this.data.img_url)
        ? this.data.img_url.map((item) => normalizeMediaUrl(item)).filter(Boolean)
        : [];

      if (images.length) {
        return images;
      }

      return this.data.one ? [normalizeMediaUrl(this.data.one)] : [];
    },
    profileCode() {
      if (this.$route.query.serial) {
        return this.$route.query.serial;
      }

      const name = String(this.data.xuanfei_name || "").trim();
      const firstLetter = /^[a-z]/i.test(name) ? name.charAt(0).toUpperCase() : "L";
      const suffix = this.data.id
        ? String(this.data.id).slice(-2).padStart(2, "0")
        : "53";

      return `${firstLetter}${suffix}`;
    },
    votingCount() {
      return this.data.dianzan || this.$route.query.like || 500;
    },
    profileHeight() {
      return this.data.hight || this.$route.query.high || 163;
    },
    profileWeight() {
      return this.data.weight || this.$route.query.weight || 48;
    },
    profileRound() {
      return this.data.bust || this.$route.query.round || 90;
    },
    serviceCity() {
      return this.data.class_name || this.$route.query.area || this.$t("detail.default_city");
    },
    summaryText() {
      return (
        this.data.vo_title ||
        this.$t("detail.default_summary")
      );
    },
    videoUrl() {
      return normalizeMediaUrl(this.data.pvideo || "");
    },
    basicInfoText() {
      return [
        `${this.$t("detail.height")} ${this.profileHeight}cm`,
        `${this.$t("detail.weight")} ${this.profileWeight}kg`,
        `${this.$t("detail.round")} ${this.profileRound}`,
      ].join(" ");
    },
  },
  methods: {
    getxuanfeidata() {
      this.$http({
        method: "get",
        url: "xuanfeidata",
        data: { id: this.$route.query.id },
      }).then((res) => {
        this.data = res.data || {};
        if (Array.isArray(this.data.img_url)) {
          this.data.img_url = this.data.img_url.map((item) => normalizeMediaUrl(item));
        }
        this.data.one = normalizeMediaUrl(this.data.one);
        this.data.pvideo = normalizeMediaUrl(this.data.pvideo);

        const lang = this.$t("auth.lang");
        const parts = String(this.data.flag || "").split("|");
        const localizedFlag =
          lang === "zh"
            ? parts[0]
            : lang === "en"
            ? parts[1]
            : lang === "ja"
            ? parts[2]
            : parts[3];

        this.data.flag = localizedFlag || "";
        this.data.flagArray = this.data.flag
          ? this.data.flag.split(/[，,]/).map((item) => item.trim()).filter(Boolean)
          : [];
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    imgShow(url) {
      const image = new Image();
      image.src = url;
      image.onload = () => {
        const previewContainer = document.createElement("div");
        previewContainer.style.position = "fixed";
        previewContainer.style.top = 0;
        previewContainer.style.right = 0;
        previewContainer.style.bottom = 0;
        previewContainer.style.left = 0;
        previewContainer.style.zIndex = 9999;
        previewContainer.style.backgroundColor = "rgba(0,0,0,0.86)";
        previewContainer.style.display = "flex";
        previewContainer.style.alignItems = "center";
        previewContainer.style.justifyContent = "center";

        const previewImage = document.createElement("img");
        previewImage.src = url;
        previewImage.style.maxWidth = "88%";
        previewImage.style.maxHeight = "88%";

        previewContainer.appendChild(previewImage);
        document.body.appendChild(previewContainer);

        previewContainer.addEventListener("click", () => {
          document.body.removeChild(previewContainer);
        });
      };
    },
    openMovie() {
      if (!this.videoUrl) {
        this.$toast(this.$t("detail.no_movie_yet"));
        return;
      }

      this.$nextTick(() => {
        const section = this.$refs.movieSection;
        if (section && typeof section.scrollIntoView === "function") {
          section.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    },
  },
  created() {
    this.getxuanfeidata();
  },
};
</script>

<style scoped lang="less">
.detail-page {
  min-height: 100%;
  background: #fff;
  padding-bottom: 56px;
}

.page-header {
  height: 112px;
  display: grid;
  grid-template-columns: 92px 1fr 92px;
  align-items: center;
  background: #fff;
  border-bottom: 2px solid #efefef;
}

.header-left {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 52px;
}

.header-title {
  text-align: center;
  color: #000;
  font-size: 30px;
  line-height: 40px;
  font-weight: 500;
}

.header-right {
  width: 92px;
  height: 92px;
}

.banner {
  padding: 0 22px;
  background: #fff;
}

.my-swipe {
  overflow: hidden;
}

.banner-img {
  display: block;
  width: 100%;
  height: 620px;
  object-fit: cover;
}

.certification-buttons {
  margin: -22px 12px 0;
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #000;
  border-radius: 38px 38px 0 0;
  padding: 6px 0 0;
  overflow: hidden;
}

.cert-btn {
  height: 46px;
  border: none;
  background: #f5e4d3;
  color: #5e5e6f;
  font-size: 18px;
  line-height: 46px;
}

.cert-btn-left {
  border-right: 2px solid #242424;
}

.detail-body {
  padding: 24px 28px 0;
  background: #fff;
}

.profile-title {
  color: #000;
  font-size: 34px;
  line-height: 44px;
  font-weight: 700;
}

.voting-info {
  margin-top: 10px;
}

.voting-text {
  color: #ff2a67;
  font-size: 22px;
  line-height: 32px;
}

.basic-info {
  margin-top: 14px;
  color: #000;
  font-size: 22px;
  line-height: 34px;
}

.service-section {
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.service-text {
  flex: 1;
  color: #000;
  font-size: 22px;
  line-height: 34px;
}

.movie-btn {
  flex-shrink: 0;
  min-width: 136px;
  height: 50px;
  border: none;
  border-radius: 25px;
  background: linear-gradient(90deg, #aa43d5 0%, #d95b9d 100%);
  color: #fff;
  font-size: 18px;
  line-height: 50px;
  font-weight: 700;
}

.summary-section {
  margin-top: 28px;
}

.movie-section {
  margin-top: 28px;
}

.movie-section-title {
  margin-bottom: 14px;
  color: #000;
  font-size: 28px;
  line-height: 38px;
  font-weight: 700;
}

.summary-title {
  color: #000;
  font-size: 28px;
  line-height: 38px;
  font-weight: 700;
}

.summary-content {
  margin-top: 14px;
  color: #28211f;
  font-size: 22px;
  line-height: 36px;
}

.detail-video {
  width: 100%;
  height: 300px;
  border-radius: 16px;
  background: #000;
}
</style>
